import React from 'react';
import Chart from 'react-google-charts';
import Loader from '../../../Utils/Loader';
import useIsMobile from '../../../../hooks/useIsMobile';

const formatRub = (value) => {
    const num = Number(value) || 0;
    return num.toLocaleString('ru-RU', { maximumFractionDigits: 2 }) + ' ₽';
};

export default function MerchantsTurnoverChart({ data, loading }) {
    const isMobile = useIsMobile();

    if (loading) {
        return <Loader />;
    }

    const rows = Array.isArray(data && data.rows) ? data.rows : [];
    const total = (data && data.total) || { successAmount: 0, successCount: 0, failCount: 0 };
    const successAmount = Number(total.successAmount || total.amount || 0);
    const successCount = Number(total.successCount || total.count || 0);
    const failCount = Number(total.failCount || 0);

    if (rows.length === 0) {
        return (
            <div style={{ padding: 20, textAlign: 'center', color: '#888' }}>
                Нет операций за выбранный период
            </div>
        );
    }

    return (
        <div>
            <div style={{ padding: '0 16px 8px 16px', color: '#555', fontSize: 14 }}>
                Итого: <b>{formatRub(successAmount)}</b> · успешных <b>{successCount}</b> · неуспешных <b>{failCount}</b>
            </div>
            <Chart
                width={'100%'}
                height={isMobile ? '360px' : '320px'}
                chartType="PieChart"
                loader={<Loader />}
                data={data}
                options={{
                    pieHole: 0.5,
                    legend: isMobile
                        ? { position: 'bottom', textStyle: { fontSize: 11 }, maxLines: 4 }
                        : { position: 'right', textStyle: { fontSize: 14 } },
                    chartArea: {
                        width: isMobile ? '92%' : '95%',
                        height: isMobile ? '62%' : '85%',
                        top: isMobile ? 24 : undefined,
                    },
                    tooltip: { isHtml: false, text: 'value' },
                    sliceVisibilityThreshold: 0.005,
                }}
            />
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/Charts/MerchantsTurnoverChart/index.js